import React, { useEffect, useState } from 'react'
import { setModalSeen } from '../redux/actions'
import { connect } from 'react-redux'
import DataSource from '../DataSource'
import NoticeFailedPayment from '../components/NoticeFailedPayment'
import NoticeUpgradeNbn from '../components/NoticeUpgradeNbn'
import NoticeEarlyBirdHomeSecure from '../components/NoticeEarlyBirdHomeSecure'
import NoticeSubscribeHomeSecure from '../components/NoticeSubscribeHomeSecure'
import NoticeSubscribeHomeSecureWithTrial from '../components/NoticeSubscribeHomeSecureWithTrial'
import NoticeInterimPayment from '../components/NoticeInterimPayment'

const Notices = (props) => {
    const [hasNotices, setHasNotices] = useState(false)
    const [type, setType] = useState(null)
    const [data, setData] = useState({})

    useEffect(() => {
        setTimeout(() => {
            getNotices().then()
        }, 2000)
    }, [])

    const getNotices = async () => {
        await DataSource.getData('/api/getNotices', response => {
            if (response && response.notice) {
                if (doShowPopup(response.notice)) {
                    setType(response.notice.type)
                    setData(response.notice.data ? response.notice.data : {})
                    setHasNotices(true)
                }
            }
        })
    }

    const doShowPopup = (notice) => {
        if (props.modals && props.modals[notice.type]) {
            const seenQty = props.modals[notice.type].seenQty
            // If they have a qty above 0, and they are equal/above the max threshold, dont show popup
            if (notice.maxSeenQty > 0 && seenQty >= notice.maxSeenQty) {
                return false
            }
        }

        return true
    }

    if (!hasNotices) {
        return null
    }

    if (type === 'failedPayment') {
        return (
            <NoticeFailedPayment
                title='Important notice'
                setModalSeen={setModalSeen}
                customerId={props.customerId}
                type={type}
                data={data}
            />
        )
    } else if (type === 'interimPayment') {
        return (
            <NoticeInterimPayment
                title='Maximum spend limit reached'
                setModalSeen={setModalSeen}
                customerId={props.customerId}
                type={type}
                data={data}
            />
        )
    }

    return null
}

const mapStateToProps = state => ({
    customerId: state.auth.id,
    residential: state.auth.residential,
    modals: state.modals[state.auth.id]
})

export default connect(mapStateToProps, { setModalSeen })(Notices)



// WEBPACK FOOTER //
// ./resources/js/modules/Notices.js